import Vue from "vue";
import VueRouter from "vue-router";

import authService from "../services/auth";

Vue.use(VueRouter);

async function checkRoles(next, permissionTo) {
  findRoles(next);

  let response = JSON.parse(localStorage.getItem("organizationRoles"));

  //Roles
  if (response) {
    let not = true;
    response.forEach(function (role) {
      if (role) {
        role.permissions.forEach(function (permission) {
          if (
            permissionTo === permission.permission &&
            permission.permissionTypes
          ) {
            permission.permissionTypes.forEach(function (permissionType) {
              if (permissionType.type === "READ" && permissionType.active) {
                not = false;
                checkLogin(next);
              }
            });
          }
        });
      }
    });
    if (not) {
      localStorage.removeItem("authorization");
      next({ name: "public.signin" });
    }
  }
}

async function findRoles(next) {
  let authentication = localStorage.getItem("authorization");

  authService
    .getRoles(authentication)
    .then((response) => {
      localStorage.setItem("organizationRoles", JSON.stringify(response.data));
    })
    .catch(function (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      } else if (error.response && error.response.status === 404) {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      } else if (error.response && error.response.status === 500) {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      } else {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      }
    });
}

async function checkLogin(next) {
  next();
}

function guard(to, from, next) {
  if (to.query.v3token) {
    localStorage.setItem('authorization', to.query.v3token);
    localStorage.setItem('userId', to.query.userId || '');
    localStorage.setItem('role', to.query.role || '');
    localStorage.setItem('organizationId', to.query.organizationId || '');
    localStorage.setItem('timeZone', to.query.timeZone || '');
    localStorage.setItem('type', 'APP');
    localStorage.setItem('v3', 'true');
    return next({
        path: to.path,
        query: { eventId: to.query.eventId },
        replace: true
      });
    


  }

  if (localStorage.getItem("authorization")) {
    let role = localStorage.getItem("role");

    if (to.meta.role === "PROFESSIONAL") {
      if (role === "PROFESSIONAL" && to.meta.permission) {
        checkRoles(next, to.meta.permission);
      } else if (role === "PROFESSIONAL" && !to.meta.permission) {
        checkLogin(next);
      } else if (role === "ADMIN") {
        checkLogin(next);
      } else if (role === "SUPERADMIN") {
        checkLogin(next);
      } else {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      }
    } else if (to.meta.role === "PATIENT") {
      if (role === "PATIENT") {
        checkLogin(next);
      } else {
        localStorage.removeItem("authorization");
        next({ name: "public.signin" });
      }
    } else if (to.meta.role === "ALL") {
      checkLogin(next);
    } else {
      next();
    }
  } else {
    next("/public/signin");
  }
}

const patientAccountChildRoute = (prop) => [
  {
    path: "account",
    name: prop + ".account",
    meta: { role: "PATIENT", auth: true, name: "Account" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Account/Account"),
  },
  {
    path: "historicclinic",
    name: prop + ".historicclinic",
    meta: { role: "PATIENT", auth: true, name: "Clinic historic" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Account/HistoricClinic"),
  },
];

const patientChildRoute = (prop) => [
  {
    path: "dashboard",
    name: prop + ".dashboard",
    meta: { role: "PATIENT", auth: true, name: "Dashboard" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Dashboard"),
  },
  {
    path: "schedule",
    name: prop + ".schedule",
    meta: { role: "PATIENT", auth: true, name: "Schedule" },
    component: () => import("../views/Pages/Patient/Schedule"),
  },
  {
    path: "session",
    name: prop + ".session",
    meta: { role: "PATIENT", auth: true, name: "Session" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Session"),
  },
  {
    path: "wallet",
    name: prop + ".wallet",
    meta: { role: "PATIENT", auth: true, name: "Wallet" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Wallet"),
  },
  {
    path: "share",
    name: prop + ".share",
    meta: { role: "PATIENT", auth: true, name: "Share" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Patient/Share"),
  },
];

const viewChildRoute = (prop) => [
  {
    path: "survey",
    name: prop + ".survey",
    meta: { name: "Survey" },
    meta: { auth: true, name: "Survey" },
    component: () => import("../views/Pages/Survey"),
  },
];

const helpsChildRoute = (prop) => [
  {
    path: "helps",
    name: prop + ".helps",
    meta: { name: "Helps" },
    meta: { auth: true, name: "Helps" },
    component: () => import("../views/Pages/Helps"),
  },
];

const helpChildRoute = (prop) => [
  {
    path: "help",
    name: prop + ".help",
    meta: { name: "Help" },
    meta: { auth: true, name: "Help" },
    component: () => import("../views/Pages/Help"),
  },
];

const rootChildRoute = (prop) => [
  {
    path: "room",
    name: prop + ".room",
    meta: { role: "ALL", auth: true, name: "Room" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Room"),
  },
  {
    path: "alert",
    name: prop + ".alert",
    meta: { role: "ALL", auth: true, name: "Alert" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Alert"),
  },
  {
    path: "rating",
    name: prop + ".rating",
    meta: { role: "PATIENT", auth: true, name: "Rating" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Rating"),
  },
  {
    path: "payment",
    name: prop + ".payment",
    meta: { role: "ALL", auth: true, name: "Payment" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Payment"),
  },
  {
    path: "ipros",
    name: prop + ".ipros",
    meta: { permission: null, role: "PROFESSIONAL", auth: true, name: "Ipros" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Ipros"),
  },
];

const publicChildRoutes = (prop) => [
  {
    path: "",
    name: "signin",
    meta: { auth: false, name: "Sign in" },
    component: () => import("../views/AuthPages/SignIn"),
  },
  {
    path: "validate",
    name: "validate",
    meta: { auth: false, name: "Validate " },
    component: () => import("../views/Pages/Validation"),
  },
  {
    path: "public/signin",
    name: prop + ".signin",
    meta: { auth: false, name: "Sign in" },
    component: () => import("../views/AuthPages/SignIn"),
  },
  {
    path: "public/signup",
    name: prop + ".signup",
    meta: { auth: false, name: "Sign up" },
    component: () => import("../views/AuthPages/SignUp"),
  },
  {
    path: "public/recover",
    name: prop + ".forgot",
    meta: { auth: false, name: "Recover password" },
    component: () => import("../views/AuthPages/RecoverPassword"),
  },
  {
    path: "newPassword",
    name: prop + ".newPassword",
    meta: { auth: false, name: "New password" },
    component: () => import("../views/AuthPages/NewPassword"),
  },
  {
    path: "public/activateAccount",
    name: prop + ".activateAccount",
    meta: { auth: false, name: "Activate account" },
    component: () => import("../views/AuthPages/ActivateAccount"),
  },
];

const professionalChildRoute = (prop) => [
  {
    path: "survey",
    name: prop + ".survey",
    meta: {
      permission: "SURVEY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Survey",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Survey"),
  },
  {
    path: "historicOld",
    name: prop + ".historicOld",
    meta: {
      permission: "CONTACT_HISTORIC",
      role: "PROFESSIONAL",
      auth: true,
      name: "Clinic historic Old",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/HistoricOld"),
  },
  {
    path: "account",
    name: prop + ".account",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "Account",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Account"),
  },
  {
    path: "share",
    name: prop + ".share",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "Share",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Share"),
  },
  {
    path: "dashboard",
    name: prop + ".dashboard",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "Dashboard",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Dashboard"),
  },
  {
    path: "role",
    name: prop + ".role",
    meta: {
      permission: "ORGANIZATION_ROLES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Role",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Role"),
  },
  {
    path: "workSchedule",
    name: prop + ".workSchedule",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "WorkSchedule",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Workschedule"),
  },
  {
    path: "wallet",
    name: prop + ".wallet",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "Wallet",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Wallet"),
  },
  {
    path: "event",
    name: prop + ".event",
    meta: { permission: null, role: "PROFESSIONAL", auth: true, name: "Event" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Event"),
  }
];

const professionalContactChildRoute = (prop) => [
  {
    path: "historicclinic",
    name: prop + ".historicclinic",
    meta: {
      permission: "CONTACT_HISTORIC",
      role: "PROFESSIONAL",
      auth: true,
      name: "Clinic historic",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Contact/HistoricClinics"),
  },
  {
    path: "recipes",
    name: prop + ".recipes",
    meta: {
      permission: "CONTACT_RECIPES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Recipes",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Recipes"),
  },
  {
    path: "listPatient",
    name: prop + ".listPatient",
    meta: {
      permission: "CONTACT_CONTACTS",
      role: "PROFESSIONAL",
      auth: true,
      name: "List Patient",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/ListPatient"),
  },
  {
    path: "contacts",
    name: prop + ".contacts",
    meta: {
      permission: "CONTACT_CONTACTS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Contacts",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Contacts"),
  },
  {
    path: "survey",
    name: prop + ".survey",
    meta: {
      permission: "SURVEY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Survey",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Survey"),
  },
  {
    path: "surveys",
    name: prop + ".surveys",
    meta: {
      permission: "SURVEY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Survey",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Surveys"),
  },
  {
    path: "surveyResponse",
    name: prop + ".surveyResponse",
    meta: {
      permission: "SURVEY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Survey",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Contact/SurveyResponse"),
  },
  {
    path: "schedule",
    name: prop + ".schedule",
    meta: {
      permission: null,
      role: "PROFESSIONAL",
      auth: true,
      name: "Schedule",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Schedule"),
  },
  {
    path: "petitioner",
    name: prop + ".petitioner",
    meta: {
      permission: "CONTACT_PETITIONER",
      role: "PROFESSIONAL",
      auth: true,
      name: "Petitioner",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Contact/Petitioner"),
  },
  {
    path: "surveyPatient",
    name: prop + ".surveyPatient",
    meta: {
      permission: "SURVEY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Survey",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Contact/SurveyPatient"),
  },
];

const professionalAdminChildRoute = (prop) => [
  {
    path: "sessions",
    name: prop + ".sessions",
    meta: {
      permission: "ADMINISTRATION_SESSIONS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Sessions",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Admin/Sessions"),
  },
  {
    path: "invoicesOld",
    name: prop + ".invoicesOld",
    meta: {
      permission: "ADMINISTRATION_INVOICES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Invoices old",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Admin/InvoicesOld"),
  },
  {
    path: "sessionsOld",
    name: prop + ".sessionsOld",
    meta: {
      permission: "ADMINISTRATION_SESSIONS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Sessions old",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Admin/SessionsOld"),
  },
  {
    path: "invoices",
    name: prop + ".invoices",
    meta: {
      permission: "ADMINISTRATION_INVOICES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Invoices",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Admin/Invoices"),
  },
  {
    path: "payments",
    name: prop + ".payments",
    meta: {
      permission: "ADMINISTRATION_PAYMENTS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Payments",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Admin/Payments"),
  },
];

const interactiveChildRoute = (prop) => [
  {
    path: "info",
    name: prop + ".info",
    meta: {
      permission: "ADMINISTRATION_SESSIONS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Info",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Interactive/Info"),
  },
  {
    path: "chat",
    name: prop + ".chat",
    meta: {
      permission: "ADMINISTRATION_SESSIONS",
      role: "PROFESSIONAL",
      auth: true,
      name: "Chat",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Interactive/Chat"),
  },
];

const professionalOrganizationChildRoute = (prop) => [
  {
    path: "professionals",
    name: prop + ".professionals",
    meta: {
      permission: "ORGANIZATION_PROFESSIONALS",
      role: "PROFESSIONAL",
      auth: true,
      name: "professionals",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Organization/Professionals"),
  },
  {
    path: "preferences",
    name: prop + ".preferences",
    meta: {
      permission: "ORGANIZATION_PREFERENCES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Preferences",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Organization/Preferences"),
  },
  {
    path: "visitType",
    name: prop + ".visitType",
    meta: {
      permission: "ORGANIZATION_VISIT_TYPES",
      role: "PROFESSIONAL",
      auth: true,
      name: "Visit type",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Organization/VisitType"),
  },
  {
    path: "activity",
    name: prop + ".activity",
    meta: {
      permission: "ORGANIZATION_ACTIVITY",
      role: "PROFESSIONAL",
      auth: true,
      name: "Activity",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Organization/Activity"),
  },
  {
    path: "rating",
    name: prop + ".rating",
    meta: {
      permission: "ORGANIZATION_RATING",
      role: "PROFESSIONAL",
      auth: true,
      name: "Rating",
    },
    beforeEnter: guard,
    component: () => import("../views/Pages/Professional/Organization/Rating"),
  },
  {
    path: "historicclinic",
    name: prop + ".historicclinic",
    meta: {
      permission: "ORGANIZATION_HISTORIC",
      role: "PROFESSIONAL",
      auth: true,
      name: "Historic clinic",
    },
    beforeEnter: guard,
    component: () =>
      import("../views/Pages/Professional/Organization/HistoricClinics"),
  },
];

const errorChildRoute = (prop) => [
  {
    path: "error/404",
    name: prop + ".error.404",
    meta: { auth: false, name: "Error 404" },
    component: () => import("../views/Error/Error404"),
  },
  {
    path: "error/500",
    name: prop + ".error.500",
    meta: { auth: false, name: "Error 500" },
    component: () => import("../views/Error/Error500"),
  },
  {
    path: "error/generic",
    name: prop + ".error.generic",
    meta: { auth: false, name: "Error generic" },
    component: () => import("../views/Error/ErrorGeneric"),
  },
];

const footerChildRoute = (prop) => [
  {
    path: "blank",
    name: prop + ".blank",
    meta: { role: "ALL", auth: true, name: "Blank" },
    beforeEnter: guard,
    component: () => import("../views/Footer/BlankAuth"),
  },
];

const routes = [
  {
    path: "/public",
    name: "",
    meta: { auth: false },
    component: () => import("../layouts/AuthLayouts/AuthLayout"),
    children: errorChildRoute("public"),
  },
  {
    path: "/public/ipros",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/Ipros"),
  },
  {
    path: "/public/recipe",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/Recipe"),
  },
  {
    path: "/public/interactive",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/InteractiveRoom"),
  },
  {
    path: "/public/interactive/payment",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/InteractiveRoomPayment"),
  },
  {
    path: "/public/petitioner",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/Petitioner"),
  },
  {
    path: "/public/wizard",
    name: "",
    meta: { auth: false },
    component: () => import("../views/Pages/Wizard"),
  },
  {
    path: "/room",
    name: "v3.room",
    meta: { role: "ALL", auth: true, name: "Room" },
    beforeEnter: guard,
    component: () => import("../views/Pages/Room"),
  },
  {
    path: "/",
    name: "",
    meta: { auth: false },
    component: () => import("../layouts/AuthLayouts/AuthLayout"),
    children: publicChildRoutes("public"),
  },
  {
    path: "/auth",
    name: "root",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: rootChildRoute("auth"),
  },
  {
    path: "/view",
    name: "view",
    meta: { auth: true },
    component: () => import("../layouts/HomeLayout"),
    children: viewChildRoute("view"),
  },
  {
    path: "/auth",
    name: "helps",
    meta: { auth: true },
    component: () => import("../layouts/HomeLayout"),
    children: helpsChildRoute("auth"),
  },
  {
    path: "/auth",
    name: "help",
    meta: { auth: true },
    component: () => import("../layouts/HomeLayout"),
    children: helpChildRoute("auth"),
  },
  {
    path: "/auth/patient",
    name: "patient",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: patientChildRoute("auth.patient"),
  },
  {
    path: "/auth/patient/account",
    name: "patient.account",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: patientAccountChildRoute("auth.patient.account"),
  },
  {
    path: "/auth/professional",
    name: "professional",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: professionalChildRoute("auth.professional"),
  },
  {
    path: "/auth/professional/contact",
    name: "professional.contact",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: professionalContactChildRoute("auth.professional.contact"),
  },
  {
    path: "/auth/professional/admin",
    name: "professional.admin",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: professionalAdminChildRoute("auth.professional.admin"),
  },
  {
    path: "/auth/professional/interactive",
    name: "professional.interactive",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: interactiveChildRoute("auth.interactive"),
  },
  {
    path: "/auth/professional/organization",
    name: "professional.organization",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: professionalOrganizationChildRoute(
      "auth.professional.organization"
    ),
  },
  {
    path: "/auth/footer",
    name: "footer",
    component: () => import("../layouts/HomeLayout"),
    beforeEnter: guard,
    children: footerChildRoute("auth.footer"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
